import type { ReactNode } from 'react';

export const symbol_multiple_airports: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m420-384 59 17q5 2 9.5-2t4.5-9v-6q0-2-5-9l-43-29v-132l138 45q6 2 11.5-2t5.5-11v-5q0-2-6-11l-149-86v-94q0-11-7-19t-18-8q-11 0-18 8t-7 19v94l-148 86q-1 1-7 12v2q0 8 6 12t13 2l136-44v132l-42 28q-2 1-6 11v3q0 7 5.5 10.5T364-368l56-16ZM582-80q-12 0-21-9t-9-21q0-6 2-11t7-10q87-88 163-197t76-224q0-81-30-154.5T693-829q-4-5-6-10t-2-11q0-13 8.5-21.5T715-880q6 0 11 2.5t10 6.5q56 51 90 140t34 179q0 115-80 237.5T603-89q-4 5-9.5 7T582-80Zm-162-79q133-121 196.5-219.5T680-552q0-118-75.5-193T420-820q-109 0-184.5 75T160-552q0 75 65 173.5T420-159Zm-21.5 55.5Q388-107 380-115q-42-38-91-87.5T198-309q-42-57-70-119t-28-124q0-150 96.5-239T420-880q127 0 223.5 89T740-552q0 92-68.5 199T460-115q-8 8-18.5 11.5T420-100q-11 0-21.5-3.5ZM420-552Z"
		/>
	</svg>
);
